/**
 * What renders while the persisted session is being resolved.
 *
 * The requirement it satisfies (authentication ADR §3) is symmetric and easy to get half right: the
 * app must never flash protected content before the session is known, AND must never flash the
 * sign-in screen for a session that is merely still resolving. So this state commits to neither —
 * it says that the app is working and nothing about whether anyone is signed in.
 *
 * The brand mark satisfies that, and it is here by the owner's decision of 18 September 2026: the
 * wait is `shared/ui/BrandLoader`, and „Ładowanie…" stays as the sr-only label the loader carries.
 * §3 asks for a state that decides no route — its words are "neutral loading state, no route
 * decided yet" — and a logo is the one thing on this screen that BOTH sides of the fork wear, so
 * it cannot be read as either. Until that date this file and its stylesheet said "no brand, no
 * illustration"; that was this app's own gloss on §3 rather than anything §3 requires, and it is
 * withdrawn.
 *
 * The router only shows it after `defaultPendingMs`, so the common cases (no session in storage, or a
 * session confirmed quickly) never reach it at all.
 */

import { useTranslation } from 'react-i18next';

import { BrandLoader } from '~/shared/ui/BrandLoader';

import styles from './SessionResolvingScreen.module.css';

export function SessionResolvingScreen() {
  const { t } = useTranslation();

  return (
    <div className={styles.screen}>
      <BrandLoader label={t('common.loading')} size="screen" />
    </div>
  );
}
